'use client';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/carousel/styles.css';
import '@mantine/code-highlight/styles.css';
import 'mantine-react-table/styles.css';
import './globals.css';

import { useEffect } from 'react';
import { MantineProvider } from '@mantine/core';

import { theme } from '@/theme';
import { useAuthStore } from '@/stores/authStore';
import { useAppModeStore } from '@/stores/appModeStore';
import { AppLayout } from '@/components/layout/AppLayout';
import { AnalyticsProvider } from '@/components/AnalyticsProvider';
import { LoginTokenExchange } from '@/components/LoginTokenExchange';

export default function RootLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    useAppModeStore.getState().initialize();
    useAuthStore.getState().initialize();
  }, []);

  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <title>ReadyLoop</title>
        <meta name="description" content="ReadyLoop voice & chat assistant" />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="theme-color" content="#1a2428" />
        <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
        <link rel="manifest" href="/manifest.webmanifest" />
        {/* Redirect away from raw RSC payload URLs.  Next.js static export
            appends /index.txt to fetch RSC payloads; on build-ID mismatch it
            does a hard navigation to that .txt URL instead of the HTML page.
            This inline script fires before React hydration and fixes the URL. */}
        <script
          dangerouslySetInnerHTML={{
            __html: `if(location.pathname.endsWith('/index.txt')){location.replace(location.pathname.replace(/\\/index\\.txt$/,'/'))}`,
          }}
        />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap"
          rel="stylesheet"
        />
      </head>
      <body>
        <AnalyticsProvider />
        <LoginTokenExchange />
        <MantineProvider theme={theme} forceColorScheme="dark">
          <AppLayout>{children}</AppLayout>
        </MantineProvider>
      </body>
    </html>
  );
}
